import type { ReactNode } from 'react';
import { CloudOff, type LucideIcon } from 'lucide-react';
import { Icon } from './Icon';

export interface EmptyStateProps {
  title: string;
  /** ОБЯЗАТЕЛЬНО: пустое состояние объясняется словами и с причиной. */
  reason: string;
  icon?: LucideIcon;
  action?: ReactNode;
  compact?: boolean;
}

/** Missing ≠ 0. Отсутствие данных никогда не рисуется нулём. */
export function EmptyState({ title, reason, icon = CloudOff, action, compact }: EmptyStateProps) {
  return (
    <div className={`empty ${compact ? 'empty--compact' : ''}`}>
      <span className="empty__icon">
        <Icon icon={icon} size={20} />
      </span>
      <span className="empty__title">{title}</span>
      <span className="empty__reason">{reason}</span>
      {action}
    </div>
  );
}
